// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/business/v1/business.proto (package no.jotta.openapi.business.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Country } from "../../country_pb.js";
import { Challenges, Credentials } from "../../credentials_pb.js";
import { TerminationSurveyCategory } from "../../customer/customer.v2_pb.js";
/**
 * @generated from message no.jotta.openapi.business.v1.BusinessUser
 */
export class BusinessUser extends Message {
    /**
     * @generated from field: string username = 1;
     */
    username = "";
    /**
     * @generated from field: string email = 2;
     */
    email = "";
    /**
     * @generated from field: string name = 3;
     */
    name = "";
    /**
     * @generated from field: uint64 storage_bytes = 4;
     */
    storageBytes = protoInt64.zero;
    /**
     * @generated from field: optional uint64 quota_bytes = 5;
     */
    quotaBytes;
    /**
     * @generated from field: bool admin = 6;
     */
    admin = false;
    /**
     * @generated from field: optional uint64 last_write_millis = 7;
     */
    lastWriteMillis;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.business.v1.BusinessUser";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "storage_bytes", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 5, name: "quota_bytes", kind: "scalar", T: 4 /* ScalarType.UINT64 */, opt: true },
        { no: 6, name: "admin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 7, name: "last_write_millis", kind: "scalar", T: 4 /* ScalarType.UINT64 */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new BusinessUser().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BusinessUser().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BusinessUser().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BusinessUser, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.business.v1.ListUsersRequest
 */
export class ListUsersRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.business.v1.ListUsersRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ListUsersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListUsersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListUsersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListUsersRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.business.v1.ListUsersResponse
 */
export class ListUsersResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.business.v1.BusinessUser users = 1;
     */
    users = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.business.v1.ListUsersResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "users", kind: "message", T: BusinessUser, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new ListUsersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListUsersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListUsersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListUsersResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.business.v1.PatchBusinessRequest
 */
export class PatchBusinessRequest extends Message {
    /**
     * @generated from field: optional string name = 1;
     */
    name;
    /**
     * @generated from field: optional string org_no = 2;
     */
    orgNo;
    /**
     * @generated from field: optional no.jotta.openapi.Country country = 3;
     */
    country;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.business.v1.PatchBusinessRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 2, name: "org_no", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 3, name: "country", kind: "enum", T: proto3.getEnumType(Country), opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new PatchBusinessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PatchBusinessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PatchBusinessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PatchBusinessRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.business.v1.PatchBusinessResponse
 */
export class PatchBusinessResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.business.v1.PatchBusinessResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new PatchBusinessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PatchBusinessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PatchBusinessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PatchBusinessResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.business.v1.CreateBusinessUserRequest
 */
export class CreateBusinessUserRequest extends Message {
    /**
     * @generated from field: string email = 1;
     */
    email = "";
    /**
     * @generated from field: string name = 2;
     */
    name = "";
    /**
     * @generated from field: optional uint64 quota_bytes = 3;
     */
    quotaBytes;
    /**
     * @generated from field: optional bool admin = 4;
     */
    admin;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.business.v1.CreateBusinessUserRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "quota_bytes", kind: "scalar", T: 4 /* ScalarType.UINT64 */, opt: true },
        { no: 4, name: "admin", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new CreateBusinessUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateBusinessUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateBusinessUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateBusinessUserRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.business.v1.CreateBusinessUserResponse
 */
export class CreateBusinessUserResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.business.v1.BusinessUser user = 1;
     */
    user;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.business.v1.CreateBusinessUserResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "user", kind: "message", T: BusinessUser },
    ]);
    static fromBinary(bytes, options) {
        return new CreateBusinessUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateBusinessUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateBusinessUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateBusinessUserResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.business.v1.PatchBusinessUserRequest
 */
export class PatchBusinessUserRequest extends Message {
    /**
     * @generated from field: string username = 1;
     */
    username = "";
    /**
     * @generated from field: optional string email = 2;
     */
    email;
    /**
     * @generated from field: optional string name = 3;
     */
    name;
    /**
     * @generated from field: optional uint64 quota_bytes = 4;
     */
    quotaBytes;
    /**
     * @generated from field: optional bool admin = 5;
     */
    admin;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.business.v1.PatchBusinessUserRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 4, name: "quota_bytes", kind: "scalar", T: 4 /* ScalarType.UINT64 */, opt: true },
        { no: 5, name: "admin", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new PatchBusinessUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PatchBusinessUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PatchBusinessUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PatchBusinessUserRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.business.v1.PatchBusinessUserResponse
 */
export class PatchBusinessUserResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.business.v1.PatchBusinessUserResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new PatchBusinessUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PatchBusinessUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PatchBusinessUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PatchBusinessUserResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.business.v1.RemoveBusinessUserRequest
 */
export class RemoveBusinessUserRequest extends Message {
    /**
     * @generated from field: string username = 1;
     */
    username = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.business.v1.RemoveBusinessUserRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new RemoveBusinessUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveBusinessUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveBusinessUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveBusinessUserRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.business.v1.RemoveBusinessUserResponse
 */
export class RemoveBusinessUserResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.business.v1.RemoveBusinessUserResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new RemoveBusinessUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveBusinessUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveBusinessUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveBusinessUserResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.business.v1.TerminateBusinessRequest
 */
export class TerminateBusinessRequest extends Message {
    /**
     * @generated from field: optional no.jotta.openapi.Credentials credentials = 1;
     */
    credentials;
    /**
     * @generated from field: optional no.jotta.openapi.business.v1.TerminateBusinessRequest.Survey survey = 2;
     */
    survey;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.business.v1.TerminateBusinessRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "credentials", kind: "message", T: Credentials, opt: true },
        { no: 2, name: "survey", kind: "message", T: TerminateBusinessRequest_Survey, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new TerminateBusinessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TerminateBusinessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TerminateBusinessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TerminateBusinessRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.business.v1.TerminateBusinessRequest.Survey
 */
export class TerminateBusinessRequest_Survey extends Message {
    /**
     * @generated from field: no.jotta.openapi.customer.v2.TerminationSurveyCategory category = 1;
     */
    category = TerminationSurveyCategory.SURVEY_CATEGORY_UNKNOWN;
    /**
     * @generated from field: string comment = 2;
     */
    comment = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.business.v1.TerminateBusinessRequest.Survey";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "category", kind: "enum", T: proto3.getEnumType(TerminationSurveyCategory) },
        { no: 2, name: "comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new TerminateBusinessRequest_Survey().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TerminateBusinessRequest_Survey().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TerminateBusinessRequest_Survey().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TerminateBusinessRequest_Survey, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.business.v1.TerminateBusinessResponse
 */
export class TerminateBusinessResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.Challenges challenges = 1;
     */
    challenges;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.business.v1.TerminateBusinessResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "challenges", kind: "message", T: Challenges },
    ]);
    static fromBinary(bytes, options) {
        return new TerminateBusinessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TerminateBusinessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TerminateBusinessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TerminateBusinessResponse, a, b);
    }
}
